import React from "react";
import classes from "./Announcements.module.css";

const Announcements = (props) => {
  return (
    <div className={classes.div}>
      Super Deal! Free shipping over 50 € purchase!
    </div>
  );
};

export default Announcements;
